import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { clipTextH5 } from '@ifeng-fe/ui_clip_text';

const TextWrap = ({ text }) => {
    const [formatText, setFormatText] = useState('');
    const [newformatText, setNewFormatText] = useState('');
    const [showMore, setShowMore] = useState(false);
    const [isClickMore, setIsClickMore] = useState(false);
    const btnRef = useRef(null);
    const wrapRef = useRef(null);

    const handleShowMore = (text) => {
        let newFormatText = text;

        if (text && btnRef.current && wrapRef.current) {
            const clipResult = clipTextH5({
                content: text,
                line: 5,
                ellipsis: '...',
                addonDom: btnRef.current,
                wrapDom: wrapRef.current,
            });

            if (clipResult.overflow) {
                setShowMore(true);
                newFormatText = clipResult.text;
            }
        }

        setFormatText(newFormatText);
        setNewFormatText(newFormatText);
    };

    useEffect(() => {
        handleShowMore(text);
    }, [text]);

    return (
        <div className={styles.wrap}>
            {formatText ? (
                <div className={styles.content} ref={wrapRef}>
                    {formatText}
                    {showMore ? (
                        <span
                            className={styles.more}
                            ref={btnRef}
                            onClick={() => {
                                setFormatText(text);
                                setShowMore(false);
                                setIsClickMore(true);
                            }}>
                            展开
                        </span>
                    ) : null}
                    {isClickMore ? (
                        <>
                            <span
                                className={styles.more}
                                ref={btnRef}
                                onClick={() => {
                                    setFormatText(newformatText);
                                    setShowMore(true);
                                    setIsClickMore(false);
                                }}>
                                收起
                            </span>
                        </>
                    ) : null}
                </div>
            ) : (
                <div className={`${styles.content} ${styles.contentInit}`} ref={wrapRef}>
                    {text}
                    <span className={styles.fold} ref={btnRef}>
                        收起
                    </span>
                </div>
            )}
        </div>
    );
};

TextWrap.propTypes = {
    text: PropTypes.string,
};

export default errorBoundary(TextWrap);
